import { useCallback, useMemo } from 'react';
import { Obstacle } from '@thive/fddm-types';

import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { SelectInput } from '@common/components/inputs';
import { useReadSelectedObstacles } from '@/modules/floorplanDesign/hooks/useReadSelectedObstacles';
import { IFddmService } from '@/modules/canvas/services/Floorplan/IFddmService';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';

const WALL_MATERIAL_OPTIONS: { label: string; value: Obstacle['wallMaterial'] }[] = [
  { label: 'Stone', value: 'STONE' },
  { label: 'Brick', value: 'BRICK' },
  { label: 'Concrete', value: 'CONCRETE' },
];

function WallMaterial() {
  const obstacles = useReadSelectedObstacles();
  const fddmSvc: IFddmService = useMemo(
    () => FddmServiceFactory.getInstance().createFddmService(),
    [],
  );

  const onChange = useCallback(
    (newValue: Obstacle['wallMaterial']) => {
      const obstacle = obstacles[0];
      fddmSvc.setPreference('obstacle.wallMaterial', newValue);
      fddmSvc.updateObstacle({
        ...obstacle,
        wallMaterial: newValue,
      });
    },
    [obstacles, fddmSvc],
  );

  if (obstacles.length !== 1) return null;

  const { wallMaterial } = obstacles[0];
  if (!wallMaterial) return null;

  return (
    <PropertiesLabel i18nkey='interface:properties.wall.material'>
      <SelectInput onChange={onChange} options={WALL_MATERIAL_OPTIONS} value={wallMaterial} />
    </PropertiesLabel>
  );
}

export default WallMaterial;
